import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ApiService, QueryParam } from 'src/app/services/api.services';
import { NavigationHistoryService } from 'src/app/services/navigation-history.service';
import { EditDeviceGroup } from '../add-device-group-main-tab.component';
import { NotAuthorizedNoticeComponent } from '../../../components/not-authorized-notice/not-authorized-notice.component';
import { HasSystemCapabilityDirective } from '../../../directives/system-capabilities/has-system-capability.directive';
import { MatDivider } from '@angular/material/list';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';

@Component({
	selector: 'app-add-device-group-name',
	templateUrl: './add-device-group-name.component.html',
	styleUrls: [
		'./add-device-group-name.component.css',
		'../../common/main.scss',
		'../../common/stepper.scss',
	],
	imports: [
		NotAuthorizedNoticeComponent,
		HasSystemCapabilityDirective,
		MatDivider,
		MatFormField,
		MatLabel,
		MatInput,
		FormsModule,
	],
})
export class AddDeviceGroupNameComponent {
	@Input() companyId?: string;

	@Input() editDeviceGroup!: EditDeviceGroup;

	@Output() groupName: EventEmitter<string> = new EventEmitter();

	deviceGroupName = '';
	isValid = false;

	public nameIsValid = true;

	groupNameChanged = new Subject<string>();

	constructor(
		private readonly apiService: ApiService,
		private readonly navHistory: NavigationHistoryService
	) {
		this.groupNameChanged
			.pipe(debounceTime(500), distinctUntilChanged())
			.subscribe(async (name) => {
				this.deviceGroupName = name;
				this.nameIsValid = await this.setNameIsValid();
				this.isValid = this.nameIsValid && this.deviceGroupName !== '';
			});
	}

	async onNameChanged(groupName: string): Promise<void> {
		this.groupNameChanged.next(groupName);
	}

	async setNameIsValid(): Promise<boolean> {
		const queryParams: QueryParam[] = [
			{ param: 'name', value: this.deviceGroupName },
			{ param: 'ownerCompanyId', value: this.companyId ?? '' },
		];
		const response = await this.apiService.getDeviceGroups(queryParams);
		const nameExists = response.some((it) => {
			return (
				it.group?.name?.toLowerCase() === this.deviceGroupName?.toLowerCase()
			);
		});
		return !nameExists;
	}
}
